// ATB Constants
// It should be part of ATB repo, but for some reason it doesn't work properly.
// Viddhiyartha Panjarethinam said we have to store it on our side until cli team resolves it.
// TODO Wipe out
module.exports = {
  CS_PHONE_NUMERIC: '1-800-289-6229',
  YOU_SAVED: 'You saved',
  REGISTRY_FOR: 'Gift Registry for',
  ATB_PROS_ZONES: ['ATBPage_ZONE_C', 'ATBPage_ZONE_D'],
};
